export { serve } from './serve';
export type {
  ExistingCache,
  ServeFromCacheResult,
  CachePolicy,
  CacheStrategy,
  ExistingCacheStrategy,
  FunctionalCacheStrategy,
  CreateCacheStrategy,
} from './types';
export { cacheStrategy } from './cache-strategy';
export { skipFunctionalTransfromSplit } from './split-functional-transform';

export const ARTIFACT_SIZE = 50_000;
